// Select all elements with the class "text-with-icons__block"
const icons = document.querySelectorAll(".text-with-icons__block");

// Initialize a counter
let counter = 1;

// Iterate through the NodeList
icons.forEach((block) => {
  // Find the child div with class "text-with-icons__icon"
  const icon = block.querySelector(".text-with-icons__icon");

  // Create a new div element
  const tooltip_wrapper = document.createElement("div");
  tooltip_wrapper.classList.add("text-with-icons__tooltip_wrapper");
  const tooltip = document.createElement("div");
  tooltip.classList.add("text-with-icons__tooltip");
  tooltip_wrapper.prepend(tooltip);

  // Set unique content for the tooltip
  if (counter == 1) {
    tooltip.textContent = "YOU DECIDE WHAT WORKS BEST FOR YOU";
  }

  if (counter == 2) {
    tooltip.textContent = "CONTAINS MCT OIL. NO SODIUM BENZOAT";
  }

  if (counter == 3) {
    tooltip.textContent =
      "WATER SOLUBLE: ABSORBS QUICKLY UNLIKE GUMMIES THAT NEED TO BE DIGESTED";
  }

  if (counter == 4) {
    tooltip.textContent =
      "MIXES WITH ANY LIQUID OR FOOD (HOT OR COLD) WITHOUT CHANGING THE FLAVOR";
  }

  if (counter == 5) {
    tooltip.textContent = "LOSE THE BOOZE... NOT THE BUZZ";
  }

  // Prepend the new div to the current block element
  block.prepend(tooltip_wrapper);

  // Increment the counter
  counter++;

  // Show the tooltip on hover for desktop
  icon.addEventListener("mouseenter", () => {
    tooltip.style.display = "block";
  });
  icon.addEventListener("mouseleave", () => {
    tooltip.style.display = "none";
  });
});

// CSS for tooltip styling
const style = document.createElement("style");
style.textContent = `
  .text-with-icons__tooltip_wrapper {
    position: relative;
    width: 100%;
  }

  .text-with-icons__tooltip {
    position: absolute;
    background-color: #d67e68;
    border-radius: 15px;
    width: 60%;
    color: #fff;
    line-height: 1.1;
    font-family: 'Bebas Neue', sans-serif;
    font-weight: bold;
    right: -50px;
    top: -40px;
    padding: 7px;
    font-size: 1rem;
    border: 2px solid #000;
    display: none; /* Initially hidden */
  }

  @media (max-width: 767px) {
    .text-with-icons__block {
      pointer-events: none;
    }
  }
`;
document.head.appendChild(style);

// Select the main div with class "text-with-icons"
const textWithIcons = document.querySelector(".text-with-icons");

if (textWithIcons) {
  // Create left arrow
  const leftArrow = document.createElement("div");
  leftArrow.classList.add("swipe-arrow", "swipe-arrow-left");
  leftArrow.innerHTML = "&#8592;"; // Left arrow symbol

  // Create right arrow
  const rightArrow = document.createElement("div");
  rightArrow.classList.add("swipe-arrow", "swipe-arrow-right");
  rightArrow.innerHTML = "&#8594;"; // Right arrow symbol

  // Append the arrows to the main div
  textWithIcons.prepend(leftArrow);
  textWithIcons.append(rightArrow);
}

// Add arrows styling
const arrowStyle = document.createElement("style");
arrowStyle.textContent = `
  .swipe-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 2rem;
    font-weight: bold;
    color: #000; /* Black arrow color */
    background-color: #fff; /* White circular background */
    border-radius: 50%; /* Circle shape */
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    pointer-events: none; /* Makes the arrows non-interactive */
    padding-bottom: 9px;
  }

  .swipe-arrow-left {
    left: 10px;
  }

  .swipe-arrow-right {
    right: 10px;
  }
  
  .text-with-icons {
    position: relative; /* Ensure the arrows are positioned relative to the container */
  }

  @media (min-width: 768px) {
    .swipe-arrow {
      display: none;
    }
  }
`;
document.head.appendChild(arrowStyle);
